import Link from "next/link";

const industries = [
  { slug: "dental", label: "Dental Practices", icon: "🦷", color: "blue" },
  { slug: "law-firms", label: "Law Firms", icon: "⚖️", color: "purple" },
  { slug: "real-estate", label: "Real Estate", icon: "🏠", color: "green" },
  { slug: "fitness", label: "Fitness Studios", icon: "💪", color: "orange" },
  { slug: "recruitment", label: "Recruitment", icon: "👥", color: "indigo" },
  { slug: "restaurants", label: "Restaurants", icon: "🍽️", color: "red" },
];

interface IndustryCrossLinksProps {
  current: string;
}

export default function IndustryCrossLinks({ current }: IndustryCrossLinksProps) {
  const others = industries.filter((ind) => ind.slug !== current);

  return (
    <section className="py-16 px-6 bg-gray-50 dark:bg-gray-900">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white mb-3">
            See How AI Works for Other Industries
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            Aditya Labs powers AI agents across multiple industries.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {others.map((ind) => (
            <Link
              key={ind.slug}
              href={`/${ind.slug}`}
              className="group bg-white dark:bg-gray-800 rounded-xl p-5 border border-gray-200 dark:border-gray-700 hover:border-blue-300 dark:hover:border-blue-600 transition text-center"
            >
              <div className="text-3xl mb-2">{ind.icon}</div>
              <p className="text-sm font-medium text-gray-900 dark:text-white group-hover:text-blue-600 dark:group-hover:text-blue-400 transition">
                {ind.label}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
